import car from './default'
import truck from './truck'
//import motorcycle from './motorcycle'
import {loadImage, prepareIcon} from "../mapUtil.js";
import {map} from "../MapView.jsx";
import {mapIcons} from "../preloadImages";
import backgroundSvg from "../../../resources/images/background.svg";
//const baseUrl = import.meta.env.PROD
//                  ? 'https://library.2ecomp.com/img/iconUber/iconsDinamicos_new_medidas'
//                  : '/icons3d';
const baseUrl = '/icons3d'
import { createTheme } from '@mui/material/styles';

export const icons = {
    default: car,
    car,
    truck
//    motorcycle
}

export const iconsRemote = {
    tractor: 'tractor_v2',
    bus: 'bus_85',
    bicycle: 'bici_40',
    boat: 'barco',
    crane: 'grua_60',
    motorcycle: 'moto_50',
    offroad: 'quadbike_45',
    pickup: 'pickup_60',
    scooter: 'scooter_40',
    van: 'furgoneta_ventana_60',
    trailer: 'micro_sv_70',
    trailer2: 'remolque_jaula',
    plane: 'helicoptero_100',
    helicopter: 'helicoptero_100'
}

export function getSVG(iconPath, height=60, width=60, viewBox="0 0 50 50") {
    return `
        <svg preserveaspectratio="none" height="${height}" width="${width}" viewBox="${viewBox}" xmlns="http://www.w3.org/2000/svg">
            ${iconPath}
        </svg>
    `
}

const background = loadImage(backgroundSvg)
const imageCache = {}

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    // adicione outras cores conforme necessário
  }
});

export default async (e, addToMap = true) => {
    if (!/^[a-z]+[0-9]?-[a-z]+-[0-9.]+$/.test(e.id)) {
        // console.log('ignoring image', e.id)
        return;
    }
    if (map.getStyle() && map.hasImage(e.id)) {
        return;
    }
    // If placeholder is available, add it synchronously to avoid MapLibre warnings
    const placeholderId = 'default-neutral-0';
    if (map.getStyle() && !map.hasImage(e.id) && imageCache[placeholderId]) {
        try {
            if (!map.hasImage(e.id)) {
                map.addImage(e.id, imageCache[placeholderId], { pixelRatio: window.devicePixelRatio });
            }
            } catch {
                // best-effort placeholder add; ignore errors
            }
    }
    if (!imageCache[e.id]) {
        const [category, color, rotation] = e.id.split('-')
        const _color = color === 'neutral'
          ? '#FE795D'
          : theme.palette[color]?.main || '#FE795D';
        if (icons[category]) {
            const svg = icons[category](rotation, _color, theme.palette);
            const svgBlob = new Blob([svg], {type: 'image/svg+xml;charset=utf-8'});
            imageCache[e.id] = await loadImage(URL.createObjectURL(svgBlob)).then(icon =>
                prepareIcon(icon))
        } else if (iconsRemote[category]) {
            const c = _color.replace('#', '')
            // fetch remote generated icon; keep caching and prepare
            try {
                imageCache[e.id] = await loadImage(`${baseUrl}/${iconsRemote[category]}.php?grados=${rotation}&a=${c}&b=${c}&c=${c}`)
                    .then(icon => prepareIcon(icon))
            } catch (err) {
                // If remote fetch fails, fallback to placeholder to avoid repeated warnings
                console.debug('icons3d: remote fetch failed for', e.id, err);
                imageCache[e.id] = imageCache[placeholderId] || null;
            }
        } else {
            imageCache[e.id] = prepareIcon(await background, await loadImage(mapIcons[category]), _color)
        }
    }

    // If we have real image data (not null) and style is ready, replace placeholder with real one
    if (map.getStyle() && addToMap && imageCache[e.id]) {
        try {
            // remove existing placeholder (if any) then add the real image
            if (map.hasImage(e.id)) {
                try { map.removeImage(e.id); } catch { /* ignore */ }
            }
            map.addImage(e.id, imageCache[e.id], { pixelRatio: window.devicePixelRatio });
        } catch (err) {
            // non-fatal; maplibre may have internal state - ignore
            console.debug('icons3d: failed to add/replace image', e.id, err);
        }
    }

    return imageCache[e.id]
}